// The one place a failed settings write becomes something a row can render (contract 22 §14).
// Pure: it takes a thrown value and returns an i18n KEY — no Vue, no store, no transport (§4).
//
// Two rules from §14 live here rather than in six call sites:
//   * a 403 reads as `workspaceSettings.error.forbidden` on the row — never the generic HTTP copy
//     and never a toast;
//   * a CANCELED request (navigation, unmount, workspace switch) renders nothing at all. v3's
//     `catch { console.error }` swallowed cancellations and real failures alike; here only the
//     cancellation is silent.
import { ApiError } from '@/shared/http'

export type SettingsWriteOutcome =
  /** The write landed. `refreshFailed` = the 07 re-read after it did not (§14). */
  | { ok: true; refreshFailed: boolean }
  /** The write failed. `errorKey` is `null` for a canceled request — render nothing. */
  | { ok: false; errorKey: string | null }

export function settingsWriteFailure(cause: unknown): SettingsWriteOutcome {
  const error = ApiError.isApiError(cause) ? cause : ApiError.fromAxios(cause)
  if (error.kind === 'canceled') return { ok: false, errorKey: null }
  if (error.kind === 'forbidden')
    return { ok: false, errorKey: 'workspaceSettings.error.forbidden' }
  return { ok: false, errorKey: error.i18nKey }
}
